/**
* Endpoint methods related to Stripe Connect Account
*/
import API from "./Api";

export default {
  /**
  * Gets the Active and Onboarded Stripe Connect Account 
  */
  async getActiveOnboarded(form){
    return API.post("/stripeconnectaccount/getactiveonboarded", form, "PLAIN_JSON");
  },

  /**
  * Creates a new Stripe Connect Account
  */
  async create(form) {
      return API.post("/stripeconnectaccount/create", form, "COOKIE_TOKEN_JSON");
  },

  /**
  * Updates a new Stripe Connect Account by account id and instance id
  */
  async update(form) {
      return API.post(`/stripeconnectaccount/update/${form.id}/${form.instance_id}`, JSON.stringify(form), "COOKIE_TOKEN_JSON");
  },

  /**
  * Deletes the Stripe Connect Account by account id and instance id
  */
  async delete(form) {
      return API.post(`/stripeconnectaccount/delete/${form.id}/${form.instance_id}`, JSON.stringify(form), "COOKIE_TOKEN_JSON");
  }
}